import { camelCase } from 'lodash-es';

import { useServiceModeContext } from 'state/service-mode';
import { ServiceMode } from 'state/service-mode/types';
import { useStoreContext } from 'state/store';
import { PosVendors } from 'utils/vendor-config';

interface IUsePosVendor {
  vendor: PosVendors | null;
}

const usePosVendor = (): IUsePosVendor => {
  const { serviceMode } = useServiceModeContext();
  const { store } = useStoreContext();

  if (!store.pos?.vendor) {
    return { vendor: null };
  }

  const vendor = camelCase(store.pos.vendor);

  return {
    vendor: (serviceMode === ServiceMode.DELIVERY
      ? vendor.concat('Delivery')
      : vendor) as PosVendors,
  };
};

export default usePosVendor;
